export const hostsData = [
    {
        id: 0,
        countryId: 'poland',
        country: 'Poland',
        city: 'Łódź',
        coordinates: [19.457216, 51.759445],
        labelX: '-6',
        labelY: '2',
        mobileX: '-6',
        mobileY: '2',
    },
    {
        id: 1,
        country: 'Germany',
        city: 'Frankfurt',
        coordinates: [8.682127, 50.110924],
        labelX: '34',
        labelY: '-10',
        mobileX: '44',
        mobileY: '-10',
    },
    {
        id: 2,
        country: 'CzechRepublic',
        city: 'Prague',
        coordinates: [14.41854, 50.073658],
        labelX: '27',
        labelY: '13',
        mobileX: '33',
        mobileY: '13',
    },
    {
        id: 3,
        country: 'Bulgaria',
        city: 'Sofia',
        coordinates: [23.319941, 42.698334],
        labelX: '32',
        labelY: '6',
        mobileX: '44',
        mobileY: '6',
    },
];

export const doesCountryHost = (country) => {
    for (let i = 0; i < hostsData.length; ++i) {
        if (hostsData[i].country.replaceAll(' ', '') === country) return true;
    }
    return false;
};
